import schedule from './schedules';
import localStorage from './local-storage';
import slugify from './slugify';
import {
  formatAwt,
  validatePersonId
} from './ui-helper';
import { svg } from './svg';
import { options, generateOptions } from './update-type';
import { countriesWithCodes } from './countries-and-codes';
import { subscriptionTypes } from './subscriptionTypes';
import { validPhone, validRange, validateLastDigits } from './numbers-only';
import { containsEmptyElements, removeEmptyItems } from './containsEmptyElements';
import { validName } from './string-validate';
import { optionsTotemVersion, getTotemInfoByVersion } from './totemVersion';
import { getTypeIcon, getPriorityIcon } from './subscriptionIcons';
import { getWaitingTime, getDifferenceTime, statusNotAllowed, restartTimer, setZeroToTimer } from './timerSubscription';
import { buildPersonDataFromClientResponse } from './externalService';

module.exports = {
  schedule,
  localStorage,
  formatAwt,
  validatePersonId,
  slugify,
  svg,
  options,
  generateOptions,
  countriesWithCodes,
  subscriptionTypes,
  validPhone,
  validRange,
  validateLastDigits,
  containsEmptyElements,
  removeEmptyItems,
  validName,
  optionsTotemVersion,
  getTotemInfoByVersion,
  getTypeIcon,
  getPriorityIcon,
  getWaitingTime,
  getDifferenceTime,
  statusNotAllowed,
  setZeroToTimer,
  restartTimer,
  buildPersonDataFromClientResponse,
};
